import axios from '../utils/axios';

export default function fetchDiversityPlansCount(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/diversity-plans-count', {
            params
        })
    )
}
